import FavoriteCountRedesign from './FavoriteCountRedesign';

export default FavoriteCountRedesign;
